import * as _ from 'lodash';

class LanguageSwitcher {
    constructor() {
        this.languageSwitcherSelector = '#language-switcher';
    }

    initialize() {
        $(this.languageSwitcherSelector).on('input', event => {
            const clickedOption = $(event.target).find(':selected');
            if (this.isActive(clickedOption)) {
                this.redirect(clickedOption.data('url'));
            }
        });
    }

    isActive(element) {
        return _.isNil(element.attr('selected'));
    }

    redirect(url) {
        window.location.replace(url);
    }
}

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./assets/js/utils/language-switcher.js